import {FC, useMemo} from "react";
import MuiTable from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import MuiTableRow from "@mui/material/TableRow";
import {GroupMembership} from "@memaro/api";
import TableRowNew from "./TableRowNew.tsx";
import TableRow from "./TableRow.tsx";
import TableContainer from "@mui/material/TableContainer";

export type TableProps = {
    rows: GroupMembership[];
    showNewRow: boolean
    onCreate: (membership: GroupMembership) => void;
    creating: boolean;
    onUpdate: (membership: GroupMembership) => void;
    updating: GroupMembership | undefined;
    onDelete: (membership: GroupMembership) => void;
    deleting: GroupMembership | undefined;
}

const Table: FC<TableProps> = ({rows, showNewRow, onCreate, creating, onUpdate, updating, onDelete, deleting}) => {
    const filteredRows = useMemo(
        () => rows
            .filter(row => row.groupIDs.length > 0)
            .sort((a, b) => a.username.localeCompare(b.username)),
        [rows]
    )
    return (
        <TableContainer sx={{height: "100%"}}>
            <MuiTable stickyHeader>
                <TableHead>
                    <MuiTableRow>
                        <TableCell>E-mailadres</TableCell>
                        <TableCell>Toegang</TableCell>
                        <TableCell></TableCell>
                    </MuiTableRow>
                </TableHead>
                <TableBody>
                    {filteredRows.map((row) => (
                        <TableRow
                            key={row.username}
                            row={row}
                            onUpdate={onUpdate}
                            updating={row.username === updating?.username}
                            onDelete={onDelete}
                            deleting={row.username === deleting?.username}
                        />
                    ))}
                    {showNewRow ? (
                        <TableRowNew onSave={onCreate} saving={creating}/>
                    ) : null}
                </TableBody>
            </MuiTable>
        </TableContainer>
    )
}

export default Table
